<template>
  <table class="table table-bordered table-hover">
    <thead class="thead-dark">
      <tr>
        <th>Лига</th>
        <th>Заезд</th>
        <th>Статус</th>
        <th>Создание</th>
        <th>Закрытие</th>
        <th>Финиш</th>
        <th>Максимальное количество участников</th>
        <th>Max place</th>
        <th>Количество участников</th>
        <th>Score threshold</th>
        <th>Score emul time step</th>
        <th>Score emul time total</th>
      </tr>
    </thead>
    <tr v-for="race in races" :key="race.id">
      <td>
        <b-link :to="{name: 'derby_leagues', params: { derbyId: derbyId }}">{{ race.league_id }}</b-link>
      </td>
      <td>
        <derby-race-link :raceId="race.id"/>
      </td>
      <td :class="raceStatusClass(race.status)">{{ race.status | raceStatusStr }}</td>
      <td>{{ race.created_at | getMomentStr }}</td>
      <td>{{ race.closed_at | getMomentStr }}</td>
      <td>{{ race.finished_at | getMomentStr }}</td>
      <td>{{ race.max_participants }}</td>
      <td>{{ race.max_place }}</td>
      <td>
        <b-link :to="{name: 'derby_race_rating', params: { raceId: race.id }}">
          {{ race.participant_count }}
        </b-link>
      </td>
      <td>{{ race.score_threshold }}</td>
      <td>{{ race.score_emul_time_step | getDurationStr }}</td>
      <td>{{ race.score_emul_time_total | getDurationStr }}</td>
    </tr>
  </table>
</template>

<script>
import { Race } from '../../model/race.js';

import DerbyRaceLink from './DerbyRaceLink.vue';

export default {
  name: 'DerbyRacesTable',

  components: {
    DerbyRaceLink,
  },

  props: {
    derbyId: {
      type: Number,
      required: true,
    },

    races: {
      type: Array,
      required: true,
    },
  },

  methods: {
    raceStatusClass(status) {
      return {
        'status-open': Race.isOpen(status),
        'status-closed': Race.isClosed(status),
        'status-finished': Race.isFinished(status),
      };
    },
  },

  filters: {
    raceStatusStr: Race.getStatusName,
  },
}
</script>

<style scoped>
.status-closed {
  background-color: #fcf8e3;
}

.status-open {
  background-color: #dff0d8;
}

.status-finished {
  background-color: #f2dede;
}
</style>
